module.exports = __webpack_public_path__ + "static/media/4_Grey_Board_01.22b0891d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/4_Grey_Board_01.jpg
// module id = 1712
// module chunks = 0